import React, { useState, useRef, useEffect } from "react";
import axios from 'axios';
import SearchIcon from "@mui/icons-material/Search";
import SendIcon from "@mui/icons-material/Send";
import EmojiPicker from "emoji-picker-react";
import PhotoIcon from "@mui/icons-material/Photo";
import MoodIcon from "@mui/icons-material/Mood";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteIcon from "@mui/icons-material/Delete";
import UserDrawer from "./UserDrawer";

function FacebookDmCompo() {
  const [userInput, setUserInput] = useState("");
  const [photoFiles, setPhotoFiles] = useState([]);
  const [emoji, setEmoji] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const chatboxRef = useRef(null);
  const domain = window.location.host;
  const [selectMessage, setSelectMessage] = useState(null);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [isOnline, setIsOnline] = useState(false);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const handleOnlineStatus = () => {
      setIsOnline(true);
      updateOnlineStatus(true);
    };

    const handleOfflineStatus = () => {
      setIsOnline(false);
      updateOnlineStatus(false);
    };

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOfflineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOfflineStatus);
    };
  }, []);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axios.get('http://localhost:3001/messages/8863008277106124');
        const messages = response.data.messages;
        setMessages(messages);
      } catch (error) {
        console.error('Erreur lors de la récupération des messages:', error);
      }
    };

    fetchMessages();
  }, []);

  const sendMessage = async () => {
    try {
      await axios.post("http://localhost:3001/webhook", {
        messaging_type: "RESPONSE",
        recipient: {
          id: selectedMessage.id,
        },
        message: {
          text: userInput,
        },
      });
      // Réinitialiser les champs de saisie et l'état selectedMessage
      setUserInput("");
      setSelectedMessage(null);
    } catch (error) {
      console.error("Erreur lors de l'envoi du message :", error);
    }
  };

  const handlePhotoUpload = (event) => {
    const files = event.target.files;
    const allowedTypes = ["image/jpeg", "image/png"];

    const selectedFiles = Array.from(files).filter((file) =>
      allowedTypes.includes(file.type)
    );

    const fileObjects = selectedFiles.map((file) => ({
      file: file,
      previewURL: URL.createObjectURL(file),
    }));

    setPhotoFiles(fileObjects);
  };

  const handleEmojiSelection = (selectedEmoji) => {
    const emojiValue = selectedEmoji.emoji;
    setEmoji((prevEmoji) => prevEmoji + emojiValue);
    setUserInput((prevUserInput) => prevUserInput + emojiValue);
  };

  const handleToggleEmojiPicker = () => {
    setShowEmojiPicker((prevState) => !prevState);
  };

  const handleDeletePhoto = (index) => {
    const updatedPhotoFiles = [...photoFiles];
    updatedPhotoFiles.splice(index, 1);
    setPhotoFiles(updatedPhotoFiles);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
  
    if (!userInput && photoFiles.length === 0 && !emoji) return;
  
    if (selectMessage) {
      try {
        if (photoFiles.length > 0) {
          for (const photoFile of photoFiles) {
            // Logique pour télécharger les photos vers votre API ici
          }
        }
        
        // Logique pour envoyer le message vers votre API ici
        setPhotoFiles([]);
        setEmoji("");
        setUserInput("");
        setShowEmojiPicker(false);
        await sendMessage();
      } catch (error) {
        console.log(error);
      }
    } else {
      alert("Please select the message that you're trying to reply to first!!");
    }
  };

  const handleOutsideClick = (event) => {
    const emojiPickerContainer = document.querySelector(
      ".emoji-picker-container"
    );
    if (emojiPickerContainer && !emojiPickerContainer.contains(event.target)) {
      setShowEmojiPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const updateOnlineStatus = async (isActive) => {
    try {
      // Update online status logic here
    } catch (error) {
      console.error("Error updating online status:", error);
    }
  };

 
  return (
    <div className="web-message-page">
      <div className="web-message-container__list">
        <div className="dm-list-header">
          <h1>Chat List</h1>
          <div className="searchbar">
            <input
              type="text"
              placeholder="Search messages... ⚡️"
              // onChange={handleSearch}
            />
            <SearchIcon />
          </div>
          <div className="dm-list-container">
            {messages.map((message, index) => (
              <div
                onClick={() => setSelectMessage(message)}
                key={message.id + index}
                className="message-list-component"
              >
                <div key={message.id}>
                  <h4>{message.id}</h4>
                  <p>{message.text}</p>
                  <p>Today at 08:34</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="web-message-container">
        <div className="webmessage-header">
          <div className="user-details">
            <p
              className={`user-profile-picture ${
                isOnline ? "online" : "offline"
              }`}
            >
              J
            </p>
            <p>John Smith</p>
            <p>{isOnline ? "Online" : "Offline"}</p>
          </div>
          <UserDrawer />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "auto auto",
            justifyContent: "center",
            flex: "center",
            alignContent: "center",
            width: "100%",
          }}
        >
          <div className="message-wrapper">
            <div className="web-message-container__chatbox" ref={chatboxRef}>
            {messages.map((message, index) => (
              <div
                key={message.id + index} // Assurez-vous que message.id est une clé unique
                onClick={() => setSelectMessage(message)}
                className={`${
                  message.senderId === domain
                    ? "bot-response-inbox"
                    : "user-response-inbox"
                } ${message === selectMessage ? "selected" : ""}`}
              >
                {message.text}
                {message.photoURL && <img src={message.photoURL} alt="Uploaded" />}
                <div className="deleteBtn">
                  <p className="truncate">
                    {message.senderId !== domain && "USER ID:" + " " + message.id}
                  </p>
                  {message.senderId === domain && (
                    <button onClick={() => setSelectedMessage(message)}>Reply</button>
                  )}
                </div>
              </div>
            ))}

            </div>
          </div>
          <div className="web-message-form">
            <form onSubmit={handleSubmit}>
              <div className="form-inputs">
                <textarea
                  name=""
                  id="web-message-input"
                  cols="30"
                  rows="10"
                  value={userInput}
                  onChange={(e) => setUserInput(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      handleSubmit(e);
                    }
                  }}
                  placeholder="Type your message..."
                />
                <div
                  className="form-options"
                  style={{
                    display: "flex",
                    flexDirection: "column-reverse",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "25px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      gap: "5px",
                      width: "100%",
                    }}
                  >
                    {photoFiles.length > 0 && (
                      <div className="photo-preview">
                        {photoFiles.map((file, index) => (
                          <div
                            key={index}
                            className="preview-image-container"
                          >
                            <img
                              src={file.previewURL}
                              alt="Preview"
                              className="preview-image"
                            />
                            <div
                              className="delete-overlay"
                              onClick={() => handleDeletePhoto(index)}
                            >
                              <DeleteIcon />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      id="photo-input"
                      onChange={handlePhotoUpload}
                      style={{ display: "none" }}
                    />
                    <label htmlFor="photo-input">
                      {photoFiles.length > 0 ? (
                        <AttachFileIcon
                          style={{ color: "green", cursor: "pointer" }}
                        />
                      ) : (
                        <AttachFileIcon
                          style={{ color: "white", cursor: "pointer" }}
                        />
                      )}
                    </label>
                    <MoodIcon
                      className={emoji ? "selected-emoji" : ""}
                      onClick={handleToggleEmojiPicker}
                      style={{ color: "white", cursor: "pointer" }}
                    />
                    {showEmojiPicker && (
                      <div className="emoji-picker-container">
                        <EmojiPicker onEmojiClick={handleEmojiSelection} />
                      </div>
                    )}
                  </div>
                  <button className="submit-btn" type="submit">
                    Send message <SendIcon />
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FacebookDmCompo;
